import { Component } from '@angular/core';

@Component({
  selector: 'app-button5',
  standalone: true,
  imports: [],
  templateUrl: './button5.component.html',
  styleUrl: './button5.component.scss'
})
export class Button5Component {

}
